import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH } from '../constants/authConstants';
import * as api from '../api';

// Helper function to get a cookie by name
const getCookie = (name) => {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
};

// Helper function to delete a cookie
// const deleteCookie = (name) => {
//     document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=None`;
// };

// Initial state
const initialState = {
    authData: getCookie('email') ? { email: getCookie('email') , avatar: getCookie('avatar')  } : null,
    isLoading: false,
    error: null,
};

// Async thunk for login
export const login = createAsyncThunk(AUTH, async (authData, thunkAPI) => {
    try {
        const response = await api.auth(authData);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Login failed');
    }
});

// Async thunk for logout
export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
    try {
        await api.logout();
        // deleteCookie('email');
        // deleteCookie('token');
        return {};
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Logout failed');
    }
});

// Redux Slice
const authSlice = createSlice({
    name: AUTH,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.isLoading = false;
                state.authData = getCookie('email') ? { email: getCookie('email'),
                    avatar: getCookie('avatar') } : null;
            })
            .addCase(login.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout.fulfilled, (state) => {
                state.authData = null;
                state.error = null;
            })
            .addCase(logout.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

export default authSlice.reducer;
